import {atom} from 'jotai';
import {ParamsInfo} from '../../../service';

export const paramsInfoAtom = atom<ParamsInfo[] | undefined>([]);
